module.exports = function() {
  return new Worker(__webpack_public_path__ + "5617924257efb2b0cc9c.worker.js");
};